const MONTHLY_PRICE = "$39.00";
const YEARLY_PRICE = "$390.00";
const FREE_PRICE = "$0.00";

export {
  MONTHLY_PRICE,
  YEARLY_PRICE,
  FREE_PRICE
}